// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5a111d56","455":"3e9a9534","977":"9d397f40"}[chunkId] + ".chunk.js";
};